module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.16448a00.png";